// Función para formatear números con separador de miles (punto)
export const formatNumber = (num: number | string | null | undefined): string => {
  if (num === null || num === undefined || isNaN(Number(num))) return "0";
  return Number(num).toLocaleString('es-EC'); // Formato Ecuador: 1.234.567
};

export const getInitials = (username: string): string => {
  if (!username) return "??";
  
  const parts = username.trim().split(/\s+/);
  
  if (parts.length >= 2) {
    // Primer nombre + primer apellido
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  
  // Si solo hay una palabra, toma las primeras 2 letras
  return username.substring(0, 2).toUpperCase();
};